module.exports = __webpack_public_path__ + "img/logo.90c4ebc7.png";